import { useMutation } from '@tanstack/react-query'
import { login } from '@/api/auth'
import { useAuthStore } from '@/stores/useAuthStore'

interface LoginRequest {
  email: string
  password: string
}

interface LoginResponse {
  access_token: string
  token_type: string
  expires_in?: number
}

/**
 * Hook for login with email/password credentials
 */
export function useLogin() {
  const setTokens = useAuthStore(state => state.setTokens)

  return useMutation({
    mutationFn: ({ email, password }: LoginRequest): Promise<LoginResponse> =>
      login(email, password),

    onSuccess: data => {
      setTokens({ accessToken: data.access_token })
    },
  })
}

/**
 * Hook for logging out — clears auth and redirects to login
 */
export function useLogout() {
  const clearAuth = useAuthStore(state => state.clear)

  return {
    logout: () => {
      clearAuth()
      window.location.href = '/login'
    },
  }
}
